import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { routeName } from "Service/env";

const CheckoutForm = forwardRef(({
                                     createPaymentIntent,
                                     isNotFilled,
                                     currentEventDetails,
                                     onPaymentMethodChange,
                                 }, ref) => {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    // Expose refreshPaymentElement method to parent component
    useImperativeHandle(ref, () => ({
        refreshPaymentElement: async () => {
            if (elements) {
                try {
                    await elements.fetchUpdates();
                    console.log('Payment Element refreshed with updated amount');
                } catch (error) {
                    console.error('Error refreshing Payment Element:', error);
                }
            }
        }
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        setIsLoading(true);
        setMessage(null);

        try {
            // Create / refresh PaymentIntent on backend
            const returnUrl =
                (await createPaymentIntent(true)) ||
                `${window.location.origin}${routeName}/payment-result`;

            const { error, paymentIntent } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: returnUrl, // Klarna redirect goes here
                },
                redirect: "if_required",
            });

            if (error) {
                setMessage(error.message);
                setIsLoading(false);
                return;
            }

            if (paymentIntent?.status === "succeeded") {
                // Instant success for cards/wallets
                window.location.href = `${routeName}/success`;
                return;
            }

            if (
                paymentIntent?.status === "requires_payment_method" &&
                paymentIntent.last_payment_error?.payment_method?.type === "klarna"
            ) {
                setMessage(
                    "Klarna is not available for the country or address you entered. Please choose another payment method."
                );
                setIsLoading(false);
                return;
            }
        } catch (err) {
            console.error(err);
            setMessage("Payment failed. Please try again.");
            setIsLoading(false);
        }
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement
                id="payment-element"
                options={{
                    fields: { billingDetails: { name: "auto", email: "auto", address: "auto" } },
                }}
                onChange={(e) => {
                    const method = e.value?.type || null;
                    onPaymentMethodChange?.((prev) => (prev === method ? prev : method));
                }}
            />
            <div className="purchase-button">
                <button
                    style={{
                        backgroundColor: isNotFilled
                            ? ((currentEventDetails?.EventColor || "#c31491") + "66")
                            : currentEventDetails?.EventColor || "#c31491",
                    }}
                    className="purchase-link"
                    disabled={isLoading || !stripe || !elements || isNotFilled}
                    id="submit"
                >
                    <span id="button-text">
                        {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
                    </span>
                </button>
            </div>

            {message && <div id="payment-message">{message}</div>}
        </form>
    );
});

export default CheckoutForm;
